import { ROLES } from '@/constants/roles';
import { isDuplicateMergePreviewEnabled } from '@/modules/UserDuplicatesMerges/services/duplicateMergePreviewContext';

export const DEV_DASHBOARD = { name: 'dev-dashboard' };

export const DEV_PAGES = [
  {
    path: '/dev/nomination-deletion',
    name: 'ui-nomination-deletion-preview',
    title: 'Удаление направлений',
    icon: '$ui-trash',
    description: 'Перенос участников, категории и состояния фонового удаления на локальных данных.',
    component: () => import('@/modules/UIDesign/Events/views/nomination-deletion-preview.vue'),
    accessList: [ROLES.organization, ROLES.event_manager],
  },
  {
    path: '/dev/duplicate-merge-preview',
    name: 'duplicate-merge-preview',
    title: 'Объединение профилей',
    icon: '$ui-user-group',
    description: 'Подтверждение и отмена объединения через email, логин и социальные способы.',
    component: () => import('@/modules/UserDuplicatesMerges/views/duplicate-merge-preview.vue'),
    accessList: Object.values(ROLES),
    canOpen: isDuplicateMergePreviewEnabled,
    restriction: 'Доступно только на localhost в локальной разработке.',
  },
  {
    path: '/dev/reports-editor',
    name: 'ui-reports-editor',
    title: 'Конструктор отчётов',
    icon: '$ui-list',
    description: 'Настройки, фильтры и предпросмотр отчётов для разных тестовых контекстов.',
    component: () => import('@/modules/UIDesign/Reports/views/editor-playground.vue'),
    accessList: [ROLES.guest, ROLES.admin, ROLES.organization, ROLES.operator, ROLES.department, ROLES.event_manager],
  },
  {
    path: '/dev/signature-auth',
    name: 'dev-signature-auth',
    title: 'Авторизация через УКЭП',
    icon: '$ui-key',
    description: 'Тестовый сертификат, выбор организации, настройка пароля и подтверждение email.',
    component: () => import('@/modules/UIDesign/Auth/views/signature-preview.vue'),
    accessList: Object.values(ROLES),
  },
];

export const canAccessDevPage = (page, user) => (user.isAuthenticated
  ? user.hasRoles(page.accessList) : page.accessList.includes(ROLES.guest));
